import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreHorizontalRegular } from "@fluentui/react-icons";
import { Close, Portal } from "@radix-ui/react-dialog";
import { useTranslation } from "react-i18next";

interface ButtonMoreMenuProps {
  onEdit: () => void;
  onDelete: () => void;
}

function ButtonMoreMenu({ onEdit, onDelete }: ButtonMoreMenuProps) {
  const { t } = useTranslation();
  return (
    <Dialog>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="icon">
            <MoreHorizontalRegular fontSize={20} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={onEdit}>
            <span>{t("edit")}</span>
          </DropdownMenuItem>
          <DialogTrigger asChild>
            <DropdownMenuItem>
              <span className="text-red-400">{t("delete")}</span>
            </DropdownMenuItem>
          </DialogTrigger>
        </DropdownMenuContent>
      </DropdownMenu>
      <Portal>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t("warning")}</DialogTitle>
          </DialogHeader>
          <div className="grid w-full gap-2 p-4">
            {t("confirm-message-for-delete")}
          </div>
          <DialogFooter>
            <Close asChild>
              <Button variant="secondary">{t("cancel")}</Button>
            </Close>
            <Close asChild>
              <Button onClick={() => onDelete()} variant="destructive">
                {t("delete")}
              </Button>
            </Close>
          </DialogFooter>
        </DialogContent>
      </Portal>
    </Dialog>
  );
}

export default ButtonMoreMenu;
